<template>
  <div class="">
    <div class="flex flex-row flex-wrap bg-middle email" @click="$refs.email_input.focus()">
      <span v-for="(email, index) in value" :key="index" class="email-entity">
        <span>{{ email.email }}</span>
        <button class="email-entity-button" @click="removeEmail(index)">
          <font-awesome-icon icon="times"/>
        </button>
      </span>
      <div contenteditable="true" class="email-input flex-auto"
        @keydown.enter.stop.prevent="onEnter"
        @keydown.delete="deleteLast"
        @click="isSuggestionActive = true"
        @keydown.stop.prevent.esc="isSuggestionActive = false"
        ref="email_input">
      </div>
    </div>
    <on-click-outside @outside="isSuggestionActive = false">
      <div class="relative">
        <div v-if='isSuggestionActive' class="suggestion">
          <ul class="list ma0 pa0">
            <li v-for="(group, index) in suggestions" :key="index" class="li ma0 pa0 suggestion-group">
              <div class="text-primary f6 fw6 ttu suggestion-group--label">{{ group.group }}</div>
              <ul v-if="group.users && group.users.length > 0" class="list ma0 pa0 ml3">
                <li v-for="(user, uIndex) in group.users" :key="uIndex" class="ma0 pa0">
                  <ul class="list ma0 pa0">
                    <li v-for="(email, eIndex) in user.emails" :key="eIndex"
                      class="ma0 pa0 suggestion-email dim"
                      @click="suggestionSelected(email)"
                    >
                      <span class="text-primary">{{ user.name }}</span>
                      <span class="text-secondary ml2 gold">{{ email }}</span>
                    </li>
                  </ul>
                </li>
              </ul>
              <div v-else class="text-secondary suggestion-empty ml3">не задан</div>
            </li>
          </ul>
        </div>
      </div>
    </on-click-outside>
    <div class="red mt1 mb2" v-if="!$v.email.email">Некорректный email</div>
  </div>
</template>

<script>
import OnClickOutside from '@/components/ui/OnClickOutside.vue'
import { email } from 'vuelidate/lib/validators'

export default {
  props: {
    value: { default: [] },
    suggestions: { default: [] }
  },
  components: {
    OnClickOutside
  },
  data () {
    return {
      email: null,
      isSuggestionActive: false
    }
  },
  validations: {
    email: {
      email // email validator
    }
  },
  methods: {
    onEnter (e) {
      this.isSuggestionActive = false
      const el = this.$refs.email_input
      this.email = el.innerText
      this.$v.email.$touch()
      if (!this.$v.$invalid) {
        this.$emit('input', this.$lo.concat(this.value, [{ email: this.email }]))
        el.innerText = ''
      }
    },
    deleteLast (e) {
      if (!this.$refs.email_input.innerText) {
        this.$emit('input', this.$lo.dropRight(this.value))
      }
    },
    removeEmail (index) {
      var emails = this.$lo.cloneDeep(this.value)
      emails.splice(index, 1)
      this.$emit('input', emails)
    },
    suggestionSelected (email) {
      this.isSuggestionActive = false
      this.$emit('input', this.$lo.concat(this.value, [{ email }]))
    }
  }
}
</script>

<style lang="scss" scoped>
.email {
  min-height: 2.25rem;
  &-input {
    outline: none;
    height: 1.75rem;
    max-height: 1.2rem;
    margin: .5rem;
  }
  &-input {
    min-width: 5rem;
  }
  &-entity {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 1.7rem;
    color: #fff; /* #334E68 $secondary-color */
    background-color:  #F9703E;// #62B0E8; #F9703E

    margin-top: .25rem;
    margin-left: .25rem;
    padding-left: .5rem;
    padding-right: 0rem;
    border-radius: 10rem;
    // font-size: .875rem;
    vertical-align: text-top;

    &-button {
      border: none;
      cursor: pointer;
      height: 100%;
      width: 2rem;
      background-color: inherit;
      color: #f1f1f1; // #99abb8;
      outline: none;
      border-radius: 10rem;
      &:hover {
        filter: opacity(0.5);
      }
    }
  }
}
.suggestion {
  position: absolute;
  box-shadow: 0 3px 6px rgba(0,0,0,.15), 0 2px 4px rgba(0,0,0,.12);
  border-radius: .25rem;
  padding: 0rem;
  max-width: 50rem;
  max-height: 20rem;
  background-color: white;
  overflow-y: scroll;

  &-group {
    padding-top: .5rem;
    padding-bottom: .25rem;
    &--label {
      margin: .5rem 1rem;
    }
  }

  &-email {
    cursor: pointer;
    padding: .5rem 1rem;
    &:hover {
      background-color: #f6f7f9;
    }
  }
  &-empty {
    cursor: default;
    padding: .25rem 1rem;
  }
}
</style>
